/**
 * @desc Yung-允许出库
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: string, options?: any) {
  return updateResponse(
    http(URL + `/rpc/outMaster/allowOutWarehouse`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
